import React, { useState, useEffect, useRef } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router"
import {
    Text,
    Flex,
    Skeleton,
} from '@chakra-ui/react';
import { NewPassword } from '../../components/NewPassword';
import { validatePassword } from "../../utils/helper";

export const VerifyLinkPage = () => {
    const [user, setUser] = useState(null);
    const [countryCode] = useState("+91");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordAgain, setNewPasswordAgain] = useState("");
    const [isPasswordError, setIsPasswordError] = useState(false);
    const [isRepeatPasswordError, setIsRepeatPasswordError] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSkeletonLoading, setIsSkeletonLoading] = useState(false);
    const [isNewPasswordRequired, setIsNewPasswordRequired] = useState(false);
    const [signinErrorMessage, setSigninErrorMessage] = useState("");
    const [isSigninError, setIsSigninError] = useState(false);
    const navigate = useNavigate();
    const didSignInRef = useRef(false)

    const onPasswordChange = (e) => {
        if (e.target.name === "new_password") {
            setNewPassword(e.target.value);
            if (!validatePassword(e.target.value)) {
                setIsPasswordError(true);
            } else {
                setIsPasswordError(false);
            }
        }
        if (e.target.name === "new_password_again") {
            setNewPasswordAgain(e.target.value);
            if (
                !validatePassword(e.target.value) ||
                newPassword.trim() !== e.target.value
            ) {
                setIsRepeatPasswordError(true);
            } else {
                setIsRepeatPasswordError(false);
            }
        }
    };

    const onNewPasswordSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            // eslint-disable-next-line no-unused-vars
            const response = await Auth.completeNewPassword(user, newPassword, {
                given_name: user?.challengeParam?.userAttributes?.given_name,
                family_name: user?.challengeParam?.userAttributes?.family_name,
            });
            setIsLoading(false);
            navigate("/");
        } catch (err) {
            setIsLoading(false);
            setIsSigninError(true);
            setSigninErrorMessage(err.message);
        }
    };

    const signIn = async (username, password) => {
        if (username === "") {
            setIsSigninError(true);
            setSigninErrorMessage("Something went wrong. Please click the verify button again from the mail.");
            return true;
        }

        try {
            const userName = isNaN(username) ? username : `${countryCode}${username}`;
            setIsSkeletonLoading(true);
            const user = await Auth.signIn(userName, password);
            setIsSkeletonLoading(false);
            if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                setUser(user);
                setIsNewPasswordRequired(true);
                setIsSigninError(false);
            }
        } catch (err) {
            setIsSkeletonLoading(false);
        }
    };

    useEffect(() => {
        if (window.location.pathname === "/verify") {
            const urlParams = new URLSearchParams(window.location.search);
            const username = urlParams.get("username");
            const password = urlParams.get("temp");

            if (username && password && !didSignInRef.current) {
                didSignInRef.current = true;
                localStorage.setItem("isNewChild", true);
                signIn(username, password);
            }
        }
    }, []);

    return (
        <Flex
            sx={{
                minHeight: "100vh",
                alignItems: { base: "flex-start", sm: "center" },
                justifyContent: { base: "flex-start", sm: "center" },
                padding: "20px",
                background: "rgb(249 250 251)",
                flexDirection: "column",
                gap: 4
            }}
        >
            {
                isSigninError ?
                    <Text
                        noWrap
                        sx={{
                            flexGrow: 1,
                            margin: "0 0 30px",
                            color: "red",
                            textAlign: "center",
                            fontSize: "xl"
                        }}
                    >
                        {signinErrorMessage}
                    </Text> :
                    <>{isSkeletonLoading ? <Skeleton height="1.5em" mx="auto" width="40%" /> :
                        <Text textAlign="center" fontSize="2xl">Please enter password to complete the verification.</Text>}</>
            }
            <NewPassword
                newPassword={newPassword}
                newPasswordAgain={newPasswordAgain}
                isPasswordError={isPasswordError}
                isRepeatPasswordError={isRepeatPasswordError}
                isLoading={isLoading}
                onPasswordChange={onPasswordChange}
                onNewPasswordSubmit={onNewPasswordSubmit}
                showPassword={showNewPassword}
                toggleShowPassword={() => setShowNewPassword(!showNewPassword)}
                isSkeletonLoading={isSkeletonLoading}
            />
        </Flex>
    );
}